const FLIT_COMPANY_UUID = "defcbb4a-0a5c-4740-8c9b-7ae6e41645ba";

export const isElectricChargingEnabled = (companyUuid?: string) =>
  import.meta.env["VITE_TARGET_ENV"] !== "production" ||
  companyUuid === FLIT_COMPANY_UUID;
